import {IBaseLookup} from "./Ibase.lookup";

export namespace WebCalculations {

	export const lookupName: string = "WebCalculations";

	export interface WebCalculations {
		webCalculationKey: number;
		name: string;
		text : string;
		ast : string;
		accepts:string;
		returns:string;
		affectingPaths:string;
		subCalculations:string;
		core:string;
		active:string;
		lastUpdated: Date;
		description: string;
	}

	export interface WebCalculationsDS extends IBaseLookup {
		webCalculations: WebCalculations[];
	}
}
